module.exports = __webpack_public_path__ + "media/npc_dota_hero_death_prophet.f8ecf465.webm";